"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerList = _interopRequireDefault(require("../../styles/dealer-list.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var DealerName = function DealerName(_ref) {
  var name = _ref.name,
    theme = _ref.theme,
    clickHandler = _ref.clickHandler,
    dealer = _ref.dealer;
  if (!(0, _checkProps["default"])(name)) {
    return /*#__PURE__*/_react["default"].createElement("h2", {
      onClick: function onClick() {
        return clickHandler(dealer);
      },
      className: _dealerList["default"].dealerName + " " + theme.headingSix
    }, name);
  }
  return null;
};
var _default = DealerName;
exports["default"] = _default;